import { Component } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export default function InfoHover({
  text,
  icon = 'fa fa-info-circle',
}: {
  text: any
  icon?: string
}) {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="button-tooltip-2">{text}</Tooltip>}
      trigger={['hover', 'focus']}
    >
      <i className={`${icon} text-muted`} />
    </OverlayTrigger>
  )
}
